import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, tap } from "rxjs/operators";
import { EventService } from "../event-service/event.service";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class CommentService {
  constructor(private eventService: EventService, private http: HttpClient) {}

  public new(attrs: any) {
    return {
      user: attrs.user,
      groupId: attrs.groupId,
      projectId: attrs.projectId,
    };
  }

  public query(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/comments`;
    return this.http
      .get(url, { params })
      .pipe(map((data: any) => data.comments || []));
  }

  public create(comment: any) {
    const url = `/api/v4/projects/${comment.projectId}/groups/${comment.groupId}/comments`;
    return this.http.post(url, { comment }).pipe(
      tap((data: any) => {
        comment.id = data.id;
        comment.createdAt = data.createdAt;

        this.eventService.publish("comment:created", comment.groupId);
      }),
    );
  }

  public destroy(comment: any) {
    const url = `/api/v4/projects/${comment.projectId}/groups/${comment.groupId}/comments/${comment.id}`;
    return this.http.delete(url).pipe(
      tap(() => {
        this.eventService.publish("comment:deleted", comment.groupId);
      }),
    );
  }
}
